<template>
    <div class="main-navigation-wrapper" :class="{'mobile-menu-opened': openedMobileMenu}">
        <button type="button"
                class="ml-auto btn btn-menu btn-outline-secondary"
                @click="openedMobileMenu = !openedMobileMenu"
        >
            <font-awesome-icon icon="bars"/>
            Menu
        </button>
        <div class="main-navigation">
            <div class="menu-wrapper">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <router-link :to="{name: 'dashboard'}" class="nav-link">Prehľad</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'assets'}" class="nav-link">Majetok</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'transactions'}" class="nav-link">Transakcie</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'profile'}" class="nav-link">Profil</router-link>
                    </li>
                    <li v-if="!isMobile" class="nav-item c-pointer">
                            <span class="nav-link">
                                Žiadosti
                                <font-awesome-icon icon="angle-down" class="text-primary"/>
                            </span>
                        <ul>
                            <li>
                                <a @click="showModal('withdrawal')">
                                    Žiadosť o vklad/výber peňažných prostriedkov
                                </a>
                            </li>
                            <li>
                                <a @click="showModal('trade')">
                                    Žiadosť o nákup/predaj cenných papierov
                                </a>
                            </li>
                        </ul>
                    </li>
                    <b-nav-item-dropdown v-if="isMobile" text="Žiadosti">
                        <b-dropdown-item @click="showModal('withdrawal')">
                            Žiadosť o vklad/výber peňažných prostriedkov
                        </b-dropdown-item>
                        <b-dropdown-item @click="showModal('trade')">
                            Žiadosť o nákup/predaj cenných papierov
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </ul>
            </div>
            <Request ref="request" :type="requestType"/>
            <div class="submenu-wrapper menu-wrapper">
                <ul class="navbar-nav">
                    <li class="nav-item c-pointer" v-if="assignedToMe.length !== 0 && !loading && !isMobile">
                        <div class="nav-link text-capitalize">
                            <div class="name-ellipsis d-table-cell pr-2">
                                {{tempUser.fullName}}
                            </div>
                            <div class="d-table-cell">
                                <font-awesome-icon icon="angle-down" class="text-primary"/>
                            </div>
                        </div>
                        <ul class="users-wrapper">
                            <li v-for="assignedUser in assignedToMe">
                                <a @click="switchUser(assignedUser.userId)">
                                    {{assignedUser.fullName}}
                                </a>
                            </li>
                        </ul>
                    </li>
                    <b-nav-item-dropdown class="users-wrapper-mobile" v-if="isMobile" :text="tempUser.fullName">
                        <b-dropdown-item v-for="assignedUser in assignedToMe" @click="switchUser(assignedUser.userId)">
                            {{assignedUser.fullName}}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <li v-if="!isMobile" class="nav-item nav-item-messages">
                        <div class="nav-link mx-0">
                            <router-link :to="{name: 'messages'}" class="btn text-white" v-b-tooltip.hover title="Správy">
                                <font-awesome-icon :icon="['far', 'envelope']"/>
                                <span class="badge" v-if="status.messages > 0">{{status.messages}}</span>
                            </router-link>
                        </div>
                    </li>
                    <li v-if="!isMobile" class="nav-item nav-item-messages">
                        <div class="nav-link mx-0">
                            <router-link :to="{name: 'exports'}" class="btn text-white" v-b-tooltip.hover title="Výpisy">
                                <font-awesome-icon :icon="['far', 'list-alt']"/>
                                <span class="badge" v-if="status.exports > 0">{{status.exports}}</span>
                            </router-link>
                        </div>
                    </li>
                    <li v-if="isMobile" class="nav-item nav-item-messages">
                        <div class="nav-link mx-0">
                            <router-link :to="{name: 'messages'}" class="btn text-white" v-b-tooltip.hover title="Správy">
                                <font-awesome-icon :icon="['far', 'envelope']"/>
                                <span class="badge" v-if="status.messages > 0">{{status.messages}}</span>
                            </router-link>
                            <router-link :to="{name: 'exports'}" class="btn text-white" v-b-tooltip.hover title="Výpisy">
                                <font-awesome-icon :icon="['far', 'list-alt']"/>
                                <span class="badge" v-if="status.exports > 0">{{status.exports}}</span>
                            </router-link>
                        </div>
                    </li>
                    <li class="nav-item">
                        <button type="button" class="btn btn-logout btn-outline-secondary float-left ml-3 mt-2 mt-md-4 ml-md-3" @click="logout()">
                            Odhlásiť
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import Request from "./Request";
    export default {
        name: "Navigation",
        components: {
            Request
        },
        computed: {
            status() {
                return this.$store.state.message.status;
            },
            loading() {
                return this.$store.state.account.loadingUser;
            },
            assignedToMe() {
                return this.$store.state.account.assignedToMe;
            },
            tempUser() {
                return this.$store.state.account.tempUser;
            }
        },
        watch: {
            '$route.path'() {
                this.openedMobileMenu = false;
            }
        },
        mounted() {
            this.$store.dispatch('message/status');
            this.loadAssignedToMe();
            this.$store.dispatch("assets/loadList", null);
            this.$store.dispatch("portfolio/portfolios");
            this.setMobile();
            this.$nextTick(function() {
                window.addEventListener("resize", this.setMobile);
            });
        },
        destroyed() {
            window.removeEventListener("resize", this.setMobile);
        },
        methods: {
            loadAssignedToMe() {
                this.$store.dispatch('account/assignedToMe')
            },
            logout() {
                this.$store.dispatch('account/logout').then(() => {
                    this.$router.push({name: 'login'})
                });
            },
            showModal(type) {
                this.requestType = type;
                this.$refs.request.show();
            },
            switchUser(userId) {
                this.$store.dispatch('account/switchUser', {login: userId});
            },
            setMobile() {
                const width = document.body.clientWidth || document.width;
                this.isMobile = width < this.mobileTable;
            }
        },
        data() {
            return {
                openedMobileMenu: false,
                isMobile: false,
                mobileTable: 1200,
                requestType: ''
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/styles/variables.scss";

    .main-navigation-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-grow: 1;

        .btn-menu {
            color: #fff;
        }

        .btn-menu {
            display: none;
        }

        .name-ellipsis {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 180px !important;
        }

        @include media-breakpoint-down(lg) {
            &.mobile-menu-opened {
                .main-navigation {
                    position: fixed;
                    top: 80px;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    background: #191919;
                    z-index: 100;
                    flex-direction: column;
                }
            }

            .btn-menu {
                display: block;
            }

            &:not(.mobile-menu-opened) {
                .main-navigation {
                    display: none;
                }
            }
        }

        @include media-breakpoint-down(md) {
            &.mobile-menu-opened {
                .main-navigation {
                    top: 60px;
                }
            }
        }

        .main-navigation {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;

            @include media-breakpoint-down(lg) {
                overflow-y: scroll;
                padding-bottom: 20px;

                .menu-wrapper {
                    width: 100%;

                    @include media-breakpoint-only(sm) {
                        max-width: 540px;
                    }
                    @include media-breakpoint-only(md) {
                        max-width: 720px;
                    }
                    @include media-breakpoint-only(lg) {
                        max-width: 960px;
                    }

                    .nav-link {
                        $height: 60px;

                        height: $height ! important;
                        line-height: $height ! important;
                        padding: 0 10px ! important;

                        border-bottom: #f2f2f2;
                    }
                }

                .submenu-wrapper {
                    width: 100%;

                    @include media-breakpoint-only(sm) {
                        max-width: 540px;
                    }
                    @include media-breakpoint-only(md) {
                        max-width: 720px;
                    }
                    @include media-breakpoint-only(lg) {
                        max-width: 960px;
                    }
                }
            }

            .navbar-nav {
                flex-direction: row;

                @include media-breakpoint-down(lg) {
                    flex-direction: column;
                }
            }
        }
    }
</style>